export type KycStatusSnapshot = {
	ourStatus: TKycStatus
	ourReason: string | null
	providerStatus: TProviderKycStatus
	providerReason: string | null
}

type KycStatusApiResponse = Partial<
	Pick<
		IKycStatusResponse,
		"our_kyc_status" | "our_kyc_reason" | "provider_kyc_status" | "provider_kyc_reason"
	>
> &
	Pick<IKycStatusResponse, "kyc_status" | "kyc_reason">

/**
 * Normalizes the new two-status KYC response. The legacy fallback keeps the
 * frontend usable during a rolling backend deployment, but all callers work
 * with the explicit our/provider model.
 */
export const getKycStatusSnapshot = (data: KycStatusApiResponse): KycStatusSnapshot => ({
	ourStatus: data.our_kyc_status ?? (data.kyc_status as TKycStatus),
	ourReason: data.our_kyc_reason !== undefined ? data.our_kyc_reason : data.kyc_reason ?? null,
	providerStatus: data.provider_kyc_status ?? data.kyc_status,
	providerReason:
		data.provider_kyc_reason !== undefined ? data.provider_kyc_reason : data.kyc_reason ?? null
})

export const isKycInProgress = (status: TKycStatus | null): boolean =>
	status === "pending" || status === "under_review"

export const isOurKycTerminal = (status: TKycStatus | null): boolean =>
	status === "approved" || status === "declined" || status === "expired" || status === "error"

export const isProviderKycPending = (status: TProviderKycStatus | null): boolean =>
	status === "none" || status === "pending" || status === "under_review"
